import styled from 'styled-components';

export const Dropdown = styled.div<{
  $isOpen: boolean;
  $align?: 'left' | 'right';
}>`
  position: absolute;
  top: calc(100% + 5px);
  z-index: 999;
  border-radius: 14px;
  pointer-events: all;
  box-shadow: -4px 4px 15px 0 ${({ theme }) => theme.palette.system['ink-10']},
    5px 5px 15px 0 ${({ theme }) => theme.palette.system['ink-10']};
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  background-color: ${({ theme }) => theme.palette.system.white};
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};

  ${({ $align = 'right' }) => ($align === 'left' ? 'left: 0;' : 'right: 0;')}
`;
